// resources/js/components/UserDocTableV3Search.js
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Icon from "@mdi/react";
import { mdiLoading, mdiMagnify, mdiTrashCanOutline } from "@mdi/js";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { setFilterToolsState, clearFilterToolsState } from '../../../store/actions/filterActions'; // Importez les actions

const UserDocTableV3Search = (props) => {
  const filterList = [
    { id: 0, label: "Filtres", code: "num", type: "text", col: "code" },
    { id: 1, label: "Numéro de dossier", code: "code", type: "text", col: "code" },
    { id: 2, label: "Type", code: "type", type: "text", col: "doctype" },
    { id: 3, label: "Insee Commune", code: "insee", type: "text", col: "insee_com" },
    { id: 4, label: "Parcelle", code: "terr", type: "text", col: "terr_code_base" },
    { id: 5, label: "Adresse", code: "address", type: "text", col: "dem_addr" },
    { id: 6, label: "Demandeur", code: "prop", type: "text", col: "dem_name" },
    { id: 10, label: "Décision", code: "state_id", type: "decision", col: "form_state.state_id" },
    { id: 7, label: "Date demande", code: "dem_date", type: "date", col: "dem_date" },
    { id: 8, label: "Date limite", code: "dem_date", type: "date", col: "form_state.date_limit" },
    { id: 9, label: "Date décision", code: "dem_date", type: "date", col: "dem_valide" },
    
  ];
  
  const [loading, setLoading] = useState(false);
  const [searchCritter, setSearchCritter] = useState("");
  const [dateSearch, setOnDateSearch] = useState([new Date(), new Date()]);
  const [decisionState, setDecisionState] = useState("");

  const decisionStateOption = [
    { id: 0, value: 0, label: "Néant", color: "#C4C4C4", border: "#CCC" },
    { id: 1, value: 1, label: "En attente", color: "#F1F1F1", border: "#CCC" },
    { id: 2, value: 2, label: "Refus", color: "#FF7168", border: "#CCC" },
    { id: 3, value: 3, label: "Sous-réserve", color: "#FFBC6D", border: "#CCC" },
    { id: 4, value: 4, label: "Favorable", color: "#58D2C3", border: "#CCC" },
    { id: 5, value: 5, label: "Tacite", color: "#CE92FC", border: "#CCC" },
  ];

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchCritter(value);
    props.setFilter({ type: props.filter?.type, value, col: props.filter?.col });
    props.onSearch(value, props.filter);
  };

  const handleCleanSearch = () => {
    setSearchCritter("");
    props.clearFilter();
    props.onSearch(null, null);
  };

  const handleselectSearch = (selectedId) => {
    const selectedFilter = filterList.find((f) => f.id === parseInt(selectedId));
    if (selectedFilter) {
      props.setFilter(selectedFilter);
      if (searchCritter.trim() !== "") { // Vérifie si la recherche n'est pas vide
        props.onSearch(searchCritter, selectedFilter);
      }
    }
  };  

  const handleSpecialSearch = () => {
    if (props.filter?.type === "date") {
      props.onSearch(dateSearch, props.filter);
    }
  };

  const handleDecisionChange = (e) => {
    const value = e.target.value;
    setDecisionState(value);
    props.setFilter({ type: 'decision', value, col: props.filter?.col });
    props.onSearch(value, props.filter);
  };

  return (
    <div className="d-flex flex-column py-2 align-items-center w-50 w-lg-75">
      <div
        className={"d-flex flex-row justify-content-center align-items-center w-100"}
        style={{ marginRight: "15rem" }}
      >
        <div
          className={"d-flex flex-row w-100 justify-content-between align-items-center "}
          style={{
            backgroundColor: "#f9f9f9",
            maxWidth: "500px",
            borderRadius: "8px",
            height: "2.7rem",
          }}
        >
          {loading ? (
            <Icon className={"p-1"} path={mdiLoading} spin={true} size={1.2} color={"var(--theme-primary)"} />
          ) : searchCritter ? (
            <div className={"p-1 px-2 rounded-lg ue-filter-search-btn"} onClick={handleCleanSearch}>
              <Icon path={mdiTrashCanOutline} size={1} color={"#82858f"} />
            </div>
          ) : (
            <div className={"p-1 px-2 rounded-lg ue-filter-search-btn"} onClick={handleSpecialSearch}>
              <Icon path={mdiMagnify} size={1.2} color={"#82858f"} />
            </div>
          )}
          {props.filter?.type === "date" ? (
            <DateRangePicker onChange={setOnDateSearch} value={dateSearch} />
          ) : props.filter?.type === "decision" ? (
            <select
              className={"custom-select mx-1"}
              value={decisionState}
              onChange={handleDecisionChange}
            >
              <option value="">Sélectionner</option>
              {decisionStateOption.map((item) => (
                <option key={item.id} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          ) : (
            <input
              id={"ueDocSearchInput"}
              className="form-control form-control border-0 "
              style={{
                backgroundColor: "unset",
                fontWeight: "505",
                opacity: "65%",
              }}
              type="text"
              placeholder={props.filter?.label || "Rechercher..."}
              value={searchCritter}
              onChange={handleSearch}
            />
          )}
        </div>
        <div className={"border-left border-gray-300 mx-1"}> </div>
        <div
          className={"ue-filter-dropdown"}
          style={{
            fontWeight: "505",
            opacity: "65%",
            height: "2.7rem",
          }}
        >
          <select
            className="custom-select mx-1"
            style={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "8px", height: "100%" }}
            value={props.filter?.id || ""}
            onChange={(e) => handleselectSearch(e.target.value)}
          >
            {filterList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  filter: state.filter.filter, // Accéder au filtre depuis Redux
  idUser: state.MeReducer.id,
  entity: state.MeReducer.entity,
  role: state.MeReducer.role,
  filterForms: state.DashboardReducer.filterForm,
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (filter) => dispatch(setFilterToolsState(filter)),
  clearFilter: () => dispatch(clearFilterToolsState()),
  setIgnKey: (e) => dispatch({ type: "SET_IGN_API_KEY", data: e }),
  setCurrentEntity: (e) =>
    dispatch({
      type: "SET_CURRENT_ENTITY",
      data: { currentEntity: e },
    }),
  showCenterSection: (e) => dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
  setCurrentCenterPage: (e, arg = null) => dispatch({ type: "SET_CURRENT_PAGE", data: e, arg: arg }),
  setDashboardFilterForm: (e) => dispatch({ type: "SET_DASHBORD_FILTER_FORM", data: e }),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDocTableV3Search);
